import {
  EMarketingCenterTemplates,
  IMarketingCenterTemplate
} from './template';
import { EMarketingCenterColorSchemes } from './colorScheme';
import { imageResponse, Pagination } from '../general';
import { EMarketingCenterFormats } from './format';
import APIService from '@/api';

export interface IMarketingCenterPost {
  title: string;
  text: string;
  color: EMarketingCenterColorSchemes;
  template: IMarketingCenterTemplate;
  brand: string;
}

export interface IMarketingCenterCreatePostDto {
  name: string;
  title: string;
  text: string;
  color: EMarketingCenterColorSchemes;
  brand: string;
  template: EMarketingCenterTemplates;
}

export interface IMarketingCenterGetAsset {
  id: string;
  publicPath: {
    url: string;
  };
  type: EMarketingCenterFormats;
  url: string;
  filename: string;
}

export interface IMarketingCenterGetPost {
  id: string;
  assets: IMarketingCenterGetAsset[];
  name: string;
  title: string;
  text: string;
  color: EMarketingCenterColorSchemes;
  brand: imageResponse;
  createdAt: string;
  updatedAt: string;
  template: EMarketingCenterTemplates;
}

export type IMarketingCenterGetList = Pagination<IMarketingCenterGetPost>;

export const getAssetsURL = (postId: string) => {
  const api = new APIService();

  return `${api.dashboardHost()}/marketing-center/social-media-templates/assets/${postId}`;
};
